import {upload} from '@/services/file-upload.service';
import DashboardApi from "@/api/DashboardApi";
import CandidacyApi from "@/api/CandidacyApi";
import TestApi from "@/api/TestApi";
import UserApi from "@/api/UserApi";

class UserService {
    getUser() {
        return JSON.parse(localStorage.getItem("user"))
    }

    getDashboardContent(from) {
        if ("Dashboard" !== from && this.dashboardResponse) {
            return this.dashboardResponse;
        }
        this.dashboardResponse = DashboardApi.getDashboardContent(this.getUser().data.id);
        return this.dashboardResponse
    }

    getCandidacyByUser() {
        return CandidacyApi.getCandidacyByUser(this.getUser().data.id);
    }

    getUserTestContent() {
        return TestApi.getUserTestContent(this.getUser().data.id)
    }

    getUserTestQuestions(idDomain) {
        return TestApi.getUserTestQuestions(this.getUser().data.id, idDomain)
    }

    debutQuestionnaire(domain) {
        return TestApi.debutQuestionnaire(this.getUser().data.id, domain);
    }

    resetQuestionnaire(id) {
        return TestApi.resetQuestionnaire(id)
    }

    terminatedTest(id) {
        return TestApi.terminatedTest(id)
    }

    saveListen(id, listen) {
        return TestApi.saveListen(id, listen)
    }

    saveAnswerQuestion(id, numQuestion, answer) {
        return TestApi.saveAnswerQuestion(id, numQuestion, answer)
    }

    sendQuestionnaire() {
        return TestApi.sendQuestionnaire(this.getUser().data.id);
    }

    saveQuestionnaireToEva() {
        return TestApi.saveQuestionnaireToEva(this.getUser().data.id)
    }

    getResponseQuestion(idDomain, numQuestion) {
        return TestApi.getResponseQuestion(idDomain, numQuestion)
    }

    saveCandidacyPartOne(idCandidacy, data) {
        let createMediaDiploma = data.diplomaMedia ? upload(data.diplomaMedia, idCandidacy, 'diploma') : [];
        let createMediaPhoto = data.photoMedia ? upload(data.photoMedia, idCandidacy, 'photoidentity') : [];
        return CandidacyApi.updateCandidacy(idCandidacy, {
            isAthlete: data.ifSportif,
            ifCarLicense: data.ifCarLicense,
            ifMotoLicense: data.ifMotoLicense,
            yearLicense: data.yearLicense ? data.yearLicense.toString() : "",
            isHandicapPerson: data.ifHandicap == true ? true : false,
            isHandicapWorker: data.ifHandicap && data.ifTravailleurHandicape == true ? true : false,
            ifReceivesSupport: data.ifHandicap && data.ifReceivesSupport == true ? true : false,
            supportOrganization: data.supportOrganization ? data.supportOrganization : "",
            typeSupport: data.supportType ? data.supportType : "",
            specificNeedsHandicap: data.besoinSpe ? data.besoinSpe : "",
            lastDiplomaCourse: data.diplomaFaculty ? data.diplomaFaculty : "",
            lastDiplomaLevel: data.diplomaLevel ? data.diplomaLevel : "",
            lastDiplomaYear: data.diplomaYear ? data.diplomaYear : "",
            lastYearStudy: data.lastLevelClass ? data.lastLevelClass : "",
            ifApprenticeshipContract: data.ifApprenticeshipContract,
            numApprenticeshipContract: data.numApprenticeshipContract ? data.numApprenticeshipContract : "",
        });
    }

    saveCandidacyPartTwo(idCandidacy, data) {

        if (data.trainingMedia1) {
            upload(data.trainingMedia1, idCandidacy, 'trainingcertificate')
        }
        if (data.trainingMedia2) {
            upload(data.trainingMedia2, idCandidacy, 'trainingcertificate2')
        }
        if (data.trainingMedia3) {
            upload(data.trainingMedia3, idCandidacy, 'trainingcertificate3')
        }
        let createMediaCv = data.cvMedia ? upload(data.cvMedia, idCandidacy, 'cv') : [];

        return CandidacyApi.updateCandidacy(idCandidacy, {
            stages: data.stages,
            professionalExperiences: data.experiences,
            isAtWork: data.ifWorkExperience,
            coverLetter: data.letter,
            ifCvBase: data.ifDiffusion,
            professionalSituation: data.professionalSituation,
            lastJob: data.lastWork
        })
    }

    sendCandidacy() {
        return CandidacyApi.sendCandidacy(this.getUser().data.id);
    }

    updateProfile(candidacy) {
        if (candidacy.candidacy_id) {
            let createMediaPhoto = candidacy.photoMedia ? upload(candidacy.photoMedia, candidacy.candidacy_id, 'photoidentity') : [];
        }
        return UserApi.updateProfile(this.getUser().data.id, candidacy);
    }

    updateEmailRequest(newEmail) {
        return UserApi.updateEmailRequest(newEmail);
    }

    extendCandidacy() {
        return CandidacyApi.extendCandidacy(this.getUser().data.id);
    }

}

export default new UserService();
